/*
 * File: AppStore.js
 * Project: patient-portal
 *
 * Created by Nate Weber on 08/10/2020
 *
 * Copyright (c) 2020 MacPractice, Inc. All rights reserved.
 *
 * Description: Mobx store for global application state.
 */

import { createContext, useContext } from "react";
import { decorate, flow, observable } from "mobx";

import AuthStore from "stores/AuthStore";

class AppStore {
  appName = "";
  auth;
  loading = false;

  constructor() {
    this.auth = new AuthStore();
    this.rehydrate();
  }

  // Loads the initial state
  loadInitialState = flow(function*() {
    this.loading = true;
    // FIXME: Need to figure out how error handling will be implemented, need to retrieve configured app title
    try {
      this.appName = yield "Online Payment Portal";
    } finally {
      this.loading = false;
    }
  });

  /**
   * Rehydrates the store.
   * This is so the app will continue to work if the user reloads
   * the page/app. Any state in this store or any of its sub-stores
   * should be loaded/set in this function.
   */
  rehydrate = flow(function*() {
    if (this.auth.isAuthenticated()) {
      yield this.auth.fetchUser();
    }
  });
}

decorate(AppStore, {
  appName: observable,
  loading: observable
});

const context = createContext(new AppStore());
export const useAppStore = () => useContext(context);

export default AppStore;
